import DotsIcon from "Assets/SVG/DotsIcon";
import List from "Components/List/List";
import { IUserDto } from "Apis/Models/IUserDto";
import { useNavigate } from "react-router-dom";
import FlexRow from "Components/FlexRow";
import { useTranslation } from "react-i18next";
import {useResetPasswordLink} from "../../../Apis/UsersApi";
import useToasts from "../../../Hooks/UseToasts";
import CopyIcon from "../../../Assets/SVG/CopyIcon";

interface IProps {
    users?: IUserDto[];
    isLoading: boolean;
    onOrderByChanged?: (orderBy: string, orderByDirection: string) => void;
}
const UsersList = (props: IProps) => {
    
    const { t } = useTranslation();

    const { showSuccessToast } = useToasts();
    
    const { users, isLoading } = props;

    const { mutateAsync: getResetLink } = useResetPasswordLink();

    const getResetPasswordLink = async (user: IUserDto) => {
        const { link } = await getResetLink(user);

        await navigator.clipboard.writeText(link)

        showSuccessToast(t('passwordLinkCopiedToClipboard'));
    }
    
    const navigate = useNavigate();
    
    return (
        <List<IUserDto> data={users} loading={isLoading} onOrderByChanged={props.onOrderByChanged} columns={[
            {
                title: t('name'),
                textRender: (record) => record.name,
                fieldName: "name",
                allowOrderBy: true
            },
            {
                title: t('email'),
                textRender: (record) => record.email,
                fieldName: "email",
                allowOrderBy: true
            },
            {
                title: t('apiKey'),
                textRender: (record) => record.apiKey
            },
            {
                title: t('customer'),
                textRender: (record) => record.customer?.name ?? "",
                fieldName: "customer",
                allowOrderBy: true
            },
            {
                title: t('permissions'),
                textRender: (record) => record.permissions.map(x => x).join(', ')
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) =>
                    <FlexRow justify={"center"} align={"center"} style={{gap: 10}}>
                        <FlexRow className={"h-100 clickable"} justify={"center"} onClick={() => getResetPasswordLink(record)}>
                            <CopyIcon width={30} height={30} />
                        </FlexRow>
                        <FlexRow className={"h-100 clickable"} justify={"center"} onClick={() => navigate(`/users/edit/${record.id}`)}>
                            <DotsIcon />
                        </FlexRow>
                    </FlexRow>
            }
        ]} keyExtractor={(record) => record.id.toString()} />
    )
}

export default UsersList;
